import { Link } from 'react-router-dom';
import './ItemsGuidePage.css';

const CATEGORIES = [
  {
    title: 'Household appliances',
    icon: '🏠',
    items: [
      'Washing machines',
      'Tumble dryers',
      'Dishwashers',
      'Electric cookers',
      'Gas cookers',
      'Ovens',
      'Hobs',
      'Extractor hoods',
      'Microwaves',
      'Boilers',
      'Water heaters',
      'Immersion heaters',
      'Metal radiators',
      'Electric radiators',
      'Metal water tanks',
      'Stainless-steel sinks',
      'Waste disposal units',
    ],
  },
  {
    title: 'Plumbing & heating scrap',
    icon: '🔧',
    items: [
      'Copper pipes',
      'Copper cylinders',
      'Copper water tanks',
      'Brass taps',
      'Brass fittings',
      'Copper fittings',
      'Radiator valves',
      'Shower valves',
      'Metal shower trays',
      'Boilers',
      'Pumps',
      'Circulation pumps',
      'Heating pumps',
      'Expansion vessels',
      'Steel pipes',
      'Cast-iron pipes',
      'Lead pipes',
      'Lead flashing',
      'Metal pipework',
      'Old heating equipment',
    ],
  },
  {
    title: 'Electrical & cable scrap',
    icon: '⚡',
    items: [
      'Copper electrical cable',
      'Armoured cable',
      'Extension cables',
      'Power cables',
      'Electrical wiring',
      'Cable offcuts',
      'Electric motors',
      'Transformers',
      'Generators',
      'Alternators',
      'Starter motors',
      'Metal consumer units',
      'Electrical control panels',
      'Switchgear',
      'Industrial electrical equipment',
      'Metal light fittings',
    ],
  },
  {
    title: 'Bikes & mobility items',
    icon: '🚲',
    items: [
      'Bicycles',
      'Mountain bikes',
      'Road bikes',
      'BMX bikes',
      "Children's bikes",
      'Bike frames',
      'Bike wheels',
      'Electric bikes',
      'Metal scooters',
      'Mobility scooters',
      'Wheelchairs',
      'Walking frames',
    ],
  },
  {
    title: 'Vehicle-related scrap',
    icon: '🚗',
    items: [
      'Car batteries',
      'Van batteries',
      'Alloy wheels',
      'Steel wheels',
      'Brake discs',
      'Brake drums',
      'Exhaust systems',
      'Catalytic converters (subject to appropriate ownership/compliance checks)',
      'Alternators',
      'Starter motors',
      'Radiators',
      'Car doors',
      'Bonnets',
      'Metal body panels',
      'Engine parts',
      'Gearboxes',
      'Suspension components',
      'Axles',
      'Metal bumpers',
    ],
  },
  {
    title: 'Building & renovation scrap',
    icon: '🏗️',
    items: [
      'Metal doors',
      'Garage doors',
      'Metal gates',
      'Metal fencing',
      'Railings',
      'Steel beams',
      'RSJs',
      'Steel columns',
      'Metal roofing sheets',
      'Aluminium window frames',
      'Aluminium door frames',
      'Metal shutters',
      'Scaffolding poles',
      'Metal handrails',
      'Metal staircases',
      'Steel mesh',
      'Rebar',
      'Metal ducting',
      'Metal trunking',
      'Copper roofing',
      'Lead flashing',
      'Metal cladding',
      'Stainless-steel panels',
    ],
  },
  {
    title: 'Garden & outdoor metal',
    icon: '🌳',
    items: [
      'Metal garden tables',
      'Metal garden chairs',
      'Metal benches',
      'Metal sheds',
      'Metal shelving',
      'Metal gates',
      'Metal fencing',
      'Metal posts',
      'Metal planters',
      'Barbecues',
      'Fire pits',
      'Metal wheelbarrows',
      'Lawnmowers',
      'Strimmers',
      'Metal garden tools',
      'Metal ladders',
      'Aluminium ladders',
      'Rotary washing lines',
      'Metal playground equipment',
    ],
  },
  {
    title: 'Furniture & household metal',
    icon: '🛏️',
    items: [
      'Metal bed frames',
      'Metal bunk beds',
      'Metal wardrobes',
      'Metal cabinets',
      'Filing cabinets',
      'Metal desks',
      'Metal tables',
      'Metal chairs',
      'Metal shelving',
      'Metal racks',
      'Metal lockers',
      'Safes',
      'Metal storage boxes',
      'Metal drawers',
      'Metal trolleys',
      'Metal coat stands',
      'Metal shelving units',
    ],
  },
  {
    title: 'Commercial kitchen scrap',
    icon: '🍽️',
    note: 'Ideal for restaurants, takeaways, hotels and commercial kitchens.',
    items: [
      'Stainless-steel preparation tables',
      'Stainless-steel sinks',
      'Commercial ovens',
      'Commercial cookers',
      'Griddles',
      'Fryers',
      'Extraction canopies',
      'Stainless-steel shelving',
      'Stainless-steel worktops',
      'Metal kitchen cabinets',
      'Catering trolleys',
      'Bain-maries',
      'Dishwashers',
      'Metal food-preparation equipment',
      'Stainless-steel containers',
      'Metal kitchen racks',
    ],
  },
  {
    title: 'Business & industrial scrap',
    icon: '🏭',
    items: [
      'Electric motors',
      'Pumps',
      'Compressors',
      'Generators',
      'Machinery',
      'Machine parts',
      'Steel workbenches',
      'Metal racking',
      'Pallet racking',
      'Metal cages',
      'Stillages',
      'Metal pallets',
      'Metal bins',
      'Metal drums (empty and safe)',
      'Metal cabinets',
      'Metal lockers',
      'Factory shelving',
      'Conveyor components',
      'Stainless-steel equipment',
      'Aluminium equipment',
      'Copper busbars',
      'Copper cable',
      'Brass components',
      'Bearings',
      'Steel offcuts',
      'Aluminium offcuts',
      'Stainless-steel offcuts',
    ],
  },
  {
    title: 'Trades & construction scrap',
    icon: '🔨',
    items: [
      'Copper pipe offcuts',
      'Electrical cable offcuts',
      'Aluminium offcuts',
      'Steel offcuts',
      'Brass fittings',
      'Old radiators',
      'Old boilers',
      'Metal sinks',
      'Metal baths',
      'Metal frames',
      'Metal ducting',
      'Cable trays',
      'Metal trunking',
      'Roofing sheets',
      'Steel beams',
      'Rebar',
      'Metal fencing',
      'Metal gates',
      'Aluminium profiles',
      'Stainless-steel sheets',
    ],
  },
  {
    title: 'Gym & leisure equipment',
    icon: '🏋️',
    items: [
      'Treadmills',
      'Exercise bikes',
      'Cross trainers',
      'Rowing machines',
      'Weight benches',
      'Weight racks',
      'Squat racks',
      'Metal gym frames',
      'Cable machines',
      'Weight plates',
      'Dumbbells',
      'Barbells',
      'Gym machines',
    ],
  },
  {
    title: 'General scrap metal',
    icon: '🔩',
    items: [
      'Copper',
      'Brass',
      'Aluminium',
      'Stainless steel',
      'Steel',
      'Cast iron',
      'Lead',
      'Zinc',
      'Bronze',
      'Copper cable',
      'Aluminium cable',
      'Metal sheets',
      'Metal bars',
      'Metal tubes',
      'Metal pipes',
      'Metal frames',
      'Metal offcuts',
      'Metal brackets',
      'Metal fixtures',
      'Scrap machinery',
      'Mixed scrap metal',
    ],
  },
];

export default function ItemsWeTakePage() {
  return (
    <div className="items-guide-page">
      <section className="items-guide-hero" aria-labelledby="items-take-heading">
        <div className="items-guide-hero-inner">
          <p className="items-guide-kicker">Accepted materials</p>
          <h1 id="items-take-heading">Items we take</h1>
          <p>
            SnapScrap collectors focus on scrap metal and metal-rich items. If it is mostly metal and
            accessible for collection, we can usually arrange a pickup.
          </p>
          <div className="items-guide-hero-actions">
            <Link className="items-guide-btn" to="/post-scrap">
              Post Scrap →
            </Link>
            <Link className="items-guide-btn items-guide-btn-secondary" to="/items-we-dont-take">
              Items we don&apos;t take
            </Link>
          </div>
        </div>
      </section>

      <section className="items-guide-section" aria-labelledby="items-take-list-heading">
        <div className="items-guide-inner items-guide-inner-wide">
          <header className="items-guide-header">
            <h2 id="items-take-list-heading">Metals and scrap we can collect</h2>
            <p>Common household, trade, and commercial scrap accepted across Leeds and nearby areas</p>
          </header>

          <div className="items-take-categories">
            {CATEGORIES.map((category) => (
              <article key={category.title} className="items-take-category">
                <h3>
                  <span aria-hidden="true">{category.icon}</span> {category.title}
                </h3>
                {category.note ? <p className="items-take-note">{category.note}</p> : null}
                <ul>
                  {category.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

          <p className="items-guide-note">
            Not sure if your load qualifies? Post photos anyway — collectors will confirm before
            arranging collection.
          </p>
        </div>
      </section>

      <section className="items-guide-cta" aria-labelledby="items-take-cta-heading">
        <h2 id="items-take-cta-heading">Ready to clear your scrap?</h2>
        <p>List your items for free and get matched with a licensed local collector.</p>
        <div className="items-guide-hero-actions">
          <Link className="items-guide-btn" to="/post-scrap">
            Post Scrap →
          </Link>
          <Link className="items-guide-btn items-guide-btn-secondary" to="/how-it-works">
            How it works
          </Link>
        </div>
      </section>
    </div>
  );
}
